import React, { useState } from "react";
import { format, isValid } from "date-fns";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import HeaderWithBreadcrumb from "../common/HeaderWithBreadcrumb";

const formatOtpDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  return isValid(date) ? format(date, "dd-MM-yyyy HH:mm:ss") : value;
};

const escapeHtml = (value) =>
  String(value).replace(
    /[&<>"']/g,
    (c) =>
      ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[
        c
      ])
  );

const OtpEnquiries = () => {
  const loggedInUserName = sessionStorage.getItem("username") || "admin";

  const [mobileNumber, setMobileNumber] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 10);
    setMobileNumber(value);
    if (error) setError("");
  };

  const handleReset = () => {
    setMobileNumber("");
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!/^[6-9]\d{9}$/.test(mobileNumber)) {
      setError("Please enter a valid 10-digit mobile number");
      return;
    }

    try {
      setLoading(true);

      const response = await axiosPostApi(apiList.FETCH_OTP_ENQUIRY, {
        username: loggedInUserName,
        mobileNumber,
      });

      const otp = response?.data?.data?.otp ?? response?.data?.otp;
      const otpDate = formatOtpDate(
        response?.data?.data?.otpDate ?? response?.data?.otpDate
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00" &&
        otp
      ) {
        CustomAlert({
          title: `OTP: ${otp}`,
          html: `OTP received for ${mobileNumber}${
            otpDate ? `<br/>on ${escapeHtml(otpDate)}` : ""
          }`,
          icon: "success",
          confirmButtonText: "Okay",
        });
      } else {
        CustomAlert({
          title: "No OTP Found",
          text:
            response?.data?.message ||
            response?.data?.respMsg ||
            "No OTP available for this mobile number.",
          icon: "info",
          confirmButtonText: "Okay",
        });
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text:
          error?.response?.data?.message ||
          "An error occurred while fetching the OTP. Please try again later.",
        icon: "error",
        confirmButtonText: "Okay",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <HeaderWithBreadcrumb title="OTP Enquiries" breadcrumb="Support Center" />
      <div className="bg-[#FFFFFF] shadow-custom rounded-[14px] p-6">
        <form onSubmit={handleSubmit} className="w-full md:w-[40%]">
          <h2 className="text-lg font-semibold text-gray-800 mb-3">
            Mobile Number <span className="text-red-500">*</span>
          </h2>
          <div className="relative w-full">
            <i className="fa fa-phone absolute left-3 top-3 text-[#FF702B] text-sm"></i>
            <input
              type="text"
              inputMode="numeric"
              value={mobileNumber}
              onChange={handleChange}
              placeholder="Enter 10-digit mobile number"
              className={`w-full border rounded-lg pl-9 pr-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#FF702B] ${
                error ? "border-red-500" : "border-gray-300"
              }`}
            />
          </div>
          {error && <p className="text-red-500 text-sm mt-1">{error}</p>}

          <div className="flex items-center gap-3 mt-5">
            <button
              type="button"
              onClick={handleReset}
              disabled={loading}
              className="bg-gray-200 hover:bg-gray-300 text-[#FF702B] font-semibold px-2 py-2 w-[160px] rounded-lg shadow-sm border-1 border-[#FF702B] transition"
            >
              Reset
            </button>
            <button
              type="submit"
              disabled={loading}
              className="bg-[#FF702B] hover:bg-[#e8601f] text-white font-semibold px-2 py-2 w-[160px] rounded-lg shadow-sm transition disabled:opacity-60"
            >
              {loading ? "Fetching..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default OtpEnquiries;
